module.exports = __webpack_public_path__ + "static/beneo3-358ce2795813ff0798a582eeb20bc6ac.png";